// validation.js or validation.ts
export const isAlphabetsAndSpacesOnly = (input) => {
  const regex = /^[A-Za-z\s]+$/;
  return regex.test(input);
};

export const htmlConvertToString = (htmlContent) => {
  const htmlContents = htmlContent || "";
  const convertedText = htmlContents.replace(/<[^>]+>/g, "");
  return convertedText;
};

export const validatePassword = (rule, value) => {
  const passwordRegex =
    /^(?=.*[0-9])(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z])(?=\S+$).{8,}$/;

  if (!value || passwordRegex.test(value)) {
    return Promise.resolve();
  }
  return Promise.reject(
    <span className="custom-error-message">
      Password must be 8 characters long, and contains 1 upper case letter, 1
      lower case letter, 1 special symbol and 1 number.
    </span>,
  );
};
